import {
  A2APayment,
  CardPayment,
  formatDateTimeReadable,
  getMerchantStructureByMerchantId,
} from '@nemuru-eng/js-api-client';

import { getSinglePaymentStatusParams } from '@/components/modules/SinglePayment/_shared/utils/getSinglePaymentStatusParams';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { useCache } from '@/hooks/requests/useCache';

interface SinglePaymentDataDisplayProps {
  singlePaymentDetails: CardPayment | A2APayment;
}

export const SinglePaymentDataDisplay = ({ singlePaymentDetails }: SinglePaymentDataDisplayProps) => {
  const { data: merchantStructure } = useCache(getMerchantStructureByMerchantId, {
    merchantId: singlePaymentDetails.merchantId,
  });

  if (!merchantStructure) return null;

  const merchantStructureEntity = MerchantStructureEntity.create({
    merchantStructure,
    agentId: singlePaymentDetails.agentId,
  });
  const agent = merchantStructureEntity.getAgent();
  if (!agent) throw new Error('Agent not found.');
  const channel = merchantStructureEntity.getChannel();
  if (!channel) throw new Error('Channel not found.');
  const merchant = merchantStructureEntity.getMerchant();

  return (
    <>
      <ReadOnlyDataRow
        labelTextId={'STATUS'}
        value={
          <>
            <StatusTag
              type={getSinglePaymentStatusParams(singlePaymentDetails.status)}
              labelTextId={singlePaymentDetails.status}
            />
          </>
        }
      />
      <ReadOnlyDataRow labelTextId={'CREATED_AT'} value={formatDateTimeReadable(singlePaymentDetails.createdAt)} />
      {singlePaymentDetails.expiredAt && (
        <ReadOnlyDataRow labelTextId={'EXPIRED_AT'} value={formatDateTimeReadable(singlePaymentDetails.expiredAt)} />
      )}
      <ReadOnlyDataRow
        labelTextId={agent?.name ? 'AGENT' : 'AGENT_ID'}
        value={agent?.name ?? singlePaymentDetails.agentId}
      />
      <ReadOnlyDataRow labelTextId={'CHANNEL'} value={channel.description} />
      <ReadOnlyDataRow labelTextId={'MERCHANT'} value={merchant.businessName} />
      {'nationality' in singlePaymentDetails && singlePaymentDetails.nationality && (
        <ReadOnlyDataRow labelTextId={'NATIONALITY'} value={singlePaymentDetails.nationality} />
      )}
      {'address' in singlePaymentDetails && singlePaymentDetails.address && (
        <ReadOnlyDataRow
          labelTextId={'ADDRESS'}
          value={`${singlePaymentDetails.address.streetAddress}${
            singlePaymentDetails.address.streetAddress2 ? ` ${singlePaymentDetails.address.streetAddress2}` : ''
          }, ${singlePaymentDetails.address.postalCode}, ${singlePaymentDetails.address.city}, ${
            singlePaymentDetails.address.country
          }`}
        />
      )}
    </>
  );
};
